import CryptoJS from 'crypto-js';


export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const preTransformRequestObject = (object) => {
    const newObject = {};

    Object.keys(object).forEach((keyName) => {
        newObject[camelToSnakeCase(keyName)] = object[keyName];
    });

    return newObject;
};

export const removePropFromObject = (obj, prop) => {
    const { [prop]: _, ...rest } = obj;

    return { ...rest };
};

export const pilotPlanes = [
    {
        key: 'Plan Basic',
        value: 'basic',
    },
    {
        key: 'Plan Pro',
        value: 'pro',
    },
    {
        key: 'Plan Advanced',
        value: 'advanced',
    },
    {
        key: 'Plan Pro + App',
        value: 'pro_pdv',
    },
    {
        key: 'Plan Advanced + App',
        value: 'advanced_pdv',
    },
];

export const INTERNATION_ISO2CODE = 'INT';  // this is a 3 length code because make sure that iso doesn't exists.

export const fixCountries = (countriesList) => {
    const newCountries = [...countriesList];
    const internationalPortal = newCountries.find((el) =>
        el.iso2_code === 'CL' && el.country.toLowerCase().trim() === 'internacional')

    const index = newCountries.findIndex((el) => el === internationalPortal);
    if (index >= 0) {
        newCountries[index] = { country: 'Internacional', iso2_code: INTERNATION_ISO2CODE }
    }

    return newCountries;
};

export const encryptData = (data, key) => CryptoJS.AES.encrypt(data, key).toString();

export const decryptData = (data, key) => CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
